module.exports = "/wwwroot/img/add-calendar.svg?ver=53405381";